<template>
    <vx-card title="Type Of Earnings">
    <div id="user-edit-tab-info">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="vx-col w-full mb-base">
                    <template>
                        <vs-table stripe  max-items="8" pagination search :data="getAllEarningsType"  >
                            
                            <template slot="thead">
                                <vs-th>Code</vs-th>
                                <vs-th>Description</vs-th>
                                <vs-th>Category</vs-th>
                                <vs-th>Taxable?</vs-th>
                                <vs-th>Bonus?</vs-th>
                                <vs-th>Add To?</vs-th>
                                <vs-th>Action</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].earningsTypeCode">
                                        {{ data[indextr].earningsTypeCode }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].earningsTypeName">
                                        {{ data[indextr].earningsTypeName }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].earningsCategoryId">
                                        {{ earningsCategory(data[indextr].earningsCategoryId).earningsCategoryName }}
                                    </vs-td>
                                    <vs-td :data="data[indextr].isTaxable">
                                        <vs-checkbox v-model="data[indextr].isTaxable" class="pointer-events-none"/>
                                    </vs-td>
                                    <vs-td :data="data[indextr].isBonus">
                                        <vs-checkbox v-model="data[indextr].isBonus" class="pointer-events-none" />
                                    </vs-td>
                                    <vs-td :data="data[indextr].addTo">
                                        {{ getAddToName(data[indextr].addTo).label }}
                                    </vs-td>
                                    <vs-td>
                                        <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" v-show="getDateDiff(data[indextr].createdOn) <= 10 ? true : false" >
                                            <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].earningsTypeId)" />
                                            <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].earningsTypeId)" />
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </template>
                </div>
            </div>
        </div>   
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button type="gradient" color="primary" @click="promptAddNewRecord()"  icon-pack="feather" icon="icon-plus">Add</vs-button>
            </div>    
        </div>


    <!-- ADD EARNINGS TYPE -->
        <vs-prompt
            class="email-compose"
            title="Add Type of Earnings"
            accept-text= "Submit"
            @accept="onAddNewRecord"
            :is-valid="validForm"
            :active.sync="activePromptAddRecord">
            <vx-card title="Please fill-out the following information">
                <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Code</span> <span style="color:red">*</span>
                            <vs-input name="code" v-validate="'required'" class="w-full" v-model="earningsType.earningsTypeCode" />
                            <span class="text-danger text-sm" v-show="errors.has('code')">{{ errors.first('code') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Description</span><span style="color:red">*</span>
                            <vs-input name="name" v-validate="'required'" class="w-full" v-model="earningsType.earningsTypeName" />
                            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Category</span><span style="color:red">*</span>
                            <v-select name="earnings category" v-validate="'required'" class="w-full" v-model="earningsCategoryName" label="earningsCategoryName" :options="getAllEarningsCategory" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('earnings category')">{{ errors.first('earnings category') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="earningsType.isTaxable" >Taxable?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="earningsType.isBonus"  >Bonus?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Add To?</span><span style="color:red">*</span>
                            <v-select name="add to" v-validate="'required'" class="w-full" v-model="addToName"  :options="getAllAddTo" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('add to')">{{ errors.first('add to') }}</span>
                        </div>
                    </div>
                
            </vx-card>
        </vs-prompt>
    <!-- END ADD EARNINGS TYPE -->
    <!-- EDIT EARNINGS -->
        <vs-prompt
                  class="email-compose"
                  title="Edit Earnings"
                  accept-text= "Submit"
                  @accept="onUpdateRecord"
                  :is-valid="validForm"
                  :active.sync="activePromptEditRecord">
                  <vx-card title="You may update the following information">
                  
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Code</span> <span style="color:red">*</span>
                            <vs-input name="code" v-validate="'required'" class="w-full" v-model="earningsType.earningsTypeCode" />
                            <span class="text-danger text-sm" v-show="errors.has('code')">{{ errors.first('code') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Description</span><span style="color:red">*</span>
                            <vs-input name="name" v-validate="'required'" class="w-full" v-model="earningsType.earningsTypeName" />
                            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Category</span><span style="color:red">*</span>
                            <v-select name="earnings category" v-validate="'required'" class="w-full" v-model="earningsCategoryName" label="earningsCategoryName" :options="getAllEarningsCategory" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('earnings category')">{{ errors.first('earnings category') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="earningsType.isTaxable" >Taxable?</vs-checkbox>
                            </div>
                        </div>
                        <div class="vx-col sm:w-1/2 w-full mb-4">
                            <div class="flex">
                                <vs-checkbox v-model="earningsType.isBonus"  >Bonus?</vs-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row mb-3" >
                        <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                            <span  class="text-sm">Add To?</span><span style="color:red">*</span>
                            <v-select name="add to" v-validate="'required'" class="w-full" v-model="addToName"  :options="getAllAddTo" placeholder="Please Select" />
                            <span class="text-danger text-sm" v-show="errors.has('add to')">{{ errors.first('add to') }}</span>
                        </div>
                    </div>

                  </vx-card>
              </vs-prompt>
    <!-- END EDIT EARNINGS -->
   </div>          
    </vx-card>     
</template>
<script>

import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Swal from 'sweetalert2'
export default {
    data() {
        return {
            earningsType: {
                earningsTypeCode: '',
                earningsTypeName: '',
                earningsCategoryId: 1,
                addTo: 0
            },
            activePromptAddRecord: false,
            activePromptEditRecord: false

        }
    },
    created() {
        this.$store.dispatch('lookup/getAllEarningsCategory').catch((err) => { console.log(err)})
        this.$store.dispatch('lookup/getAllEarningsType').catch((err) => { console.log(err)})
      
    },
    components: {
         'v-select': vSelect,
        Datepicker,
        flatPickr,
    },
    computed: {
        getAllEarningsType() {
            return this.$store.state.lookup.getAllEarningsType
        },
        getAllEarningsCategory() {
            return this.$store.state.lookup.getAllEarningsCategory
        },
        getAllAddTo() {
            return this.$store.state.lookup.addToLookup
        },
        earningsCategoryName: {
            get() { return this.$store.getters['lookup/earningsCategoryLookup'](this.earningsType.earningsCategoryId) },
            set(obj) { this.earningsType.earningsCategoryId = obj.earningsCategoryId }
        },
        addToName: {
            get() { return this.$store.getters['lookup/addToLookup'](this.earningsType.addTo) },
            set(obj) { this.earningsType.addTo = obj.value }
        },
        earningsCategory() {
            return (id) => this.$store.getters['lookup/earningsCategoryLookup'](id) 
        },
        getAddToName() {
            return (id) => this.$store.getters['lookup/addToLookup'](id) 
        },
       
        validForm() {

        },
        getDateDiff(){
            return (createdOn) => {
                var oneDay = 1
                if (createdOn !== null && this.currentDate !== null) {
                        var date1 = new Date(moment(createdOn).format("MM-DD-YYYY"))
                        var date2 = new Date(moment(this.currentDate).format("MM-DD-YYYY"))

                        var timeDiff = Math.abs(date2.getTime() - date1.getTime())
                        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
                        if (diffDays !== 'NaN') {
                           return diffDays + oneDay  
                        } else { return 0 }
                }
            }

        },
        
    },
    methods: {
        promptAddNewRecord() {
            this.activePromptAddRecord = true
        },
        onAddNewRecord() {
            this.$vs.loading()
            this.$store.dispatch('lookup/addEarningsType', this.earningsType)
                .then((response) => {
                    this.$vs.loading.close()
                    if(response.status == 200)
                        this.$alert("", 'Save Successfully', "success")
                })
                .catch((error) => {
                    this.$vs.loading.close()
                    this.$alert(error, 'Error', "error")
                })
        },
        editRecord(id) {
            

            const e = this.$store.getters['lookup/earningsTypeLookup'](id)
            
            this.earningsType.earningsTypeId = id,
            this.earningsType.earningsTypeCode = e.earningsTypeCode,
            this.earningsType.earningsTypeName = e.earningsTypeName
            this.earningsType.earningsCategoryId = e.earningsCategoryId,
            this.earningsType.isTaxable = e.isTaxable,
            this.earningsType.isBonus = e.isBonus,
            this.earningsType.addTo = e.addTo

            this.activePromptEditRecord = true
        },
        onUpdateRecord() {
            this.$vs.loading()
            this.$store.dispatch('lookup/updateEarningsType', this.earningsType)
                .then((response) => {
                    this.$vs.loading.close()
                    if(response.status == 200)
                        this.$alert("", 'Updated Successfully', "success")
                })
                .catch((error) => {
                    this.$vs.loading.close()
                    this.$alert(error, 'Error', "error")
                })
        },
        confirmDeleteRecord(id) {
           Swal.fire({
              title: 'Are you sure you want to <strong>continue</strong>?' ,
              text: "",
              icon: 'warning',
              customClass: {
                  icon: "no-before-icon",
              },
              showCancelButton: true,
              confirmButtonColor: '3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Confirm',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$vs.loading()
                    this.$store.dispatch('lookup/deleteEarningsType', id)
                        .then((response) => {
                            this.$vs.loading.close()
                            if(response.status == 200) {
                                this.$alert("", 'Deleted Successfully', "success")
                            }
                                
                        })
                        .catch((error) => {
                            this.$vs.loading.close()
                            this.$alert(error, 'Error', "error")
                        })
                } else
                    this.$alert("", 'Cancelled Delete', "success")
            })
        }
    }
       
}
</script>